import { useMemo } from "react"
import { api } from "~/utils/api"

type Props = {
  collectionIds: number[]
  enabled?: boolean
}

export function useCollectionBudgetData({ collectionIds, enabled = true }: Props) {
  const { data: allBudgets, isLoading: budgetsLoading } = api.budgets.getAll.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  })

  const budget = useMemo(() => {
    if (!allBudgets || collectionIds.length === 0) return null
    return allBudgets.find((b) =>
      (b.collectionIds ?? []).some((cid) => collectionIds.includes(cid)),
    )
  }, [allBudgets, collectionIds])

  const { data: budgetData, isLoading: variantsLoading } =
    api.budgets.getVariantForecastsForBudget.useQuery(
      { budgetId: budget?.id ?? 0 },
      {
        enabled: enabled && !!budget,
        staleTime: 5 * 60 * 1000,
      },
    )

  const budgetMap = useMemo(() => {
    const map = new Map<string, number>()
    if (!budgetData?.variants) return map
    for (const v of budgetData.variants) {
      map.set(v.variantId, v.allocatedBudgetUnits)
    }
    return map
  }, [budgetData])

  return {
    budget,
    budgetMap,
    hasBudget: !!budget,
    isLoading: budgetsLoading || (!!budget && variantsLoading),
  }
}
